import { CommonModule } from '@angular/common';

import { APP_INITIALIZER, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { PinchZoomModule } from '@mapaxe/ngx-pinch-zoom';
import { ImgFallbackComponent } from '@shared/components/img-fallback/img-fallback.component';
import { AspectRatioComponent } from './aspect-ratio/aspect-ratio.component';
import { AppShellConfig } from './config/app-shell.config';
import { ImageShellComponent } from './image-shell/image-shell.component';
import { TextShellComponent } from './text-shell/text-shell.component';

@NgModule({
    declarations: [
        AspectRatioComponent,
        ImageShellComponent,
        TextShellComponent,
        ImgFallbackComponent,
    ],
    providers: [
        // Inspired in: https://devblogs.microsoft.com/premier-developer/angular-how-to-editable-config-files/
        {
            provide: APP_INITIALIZER,
            useFactory: (appShellConfig: AppShellConfig) => () => appShellConfig.load(),
            deps: [AppShellConfig],
            multi: true,
        },
    ],
    imports: [CommonModule, IonicModule, PinchZoomModule],
    exports: [AspectRatioComponent, ImageShellComponent, TextShellComponent, ImgFallbackComponent],
})
export class ShellModule {}
